import {
	SET_FORM_STATE,
	GET_ALGORITHMS_CITIES,
	GET_ALGORITHMS_DATES,
	RUN_ALGORITHM_OVERSHOOTING
} from '../actions/AlgorithmsActions';

const initialState = {
	algoCities: [],
	algoDates: [],
	formState: {
		isValid: false,
		values: {
			tech2g: false,
			tech3g: false,
			tech4g: false,
			algoSelectedCity: '',
			algoSelectedDate: '',
			northEastLatitude: 51.970581074166546,
			northEastLongitude: -0.2727386662149663,
			southWestLatitude: 51.82561957967412,
			southWestLongitude: -0.7059153010141366,
			algoSelectedTab: 'byCoordinates',
			algoInputFilePath: '',
			// 2G
			numberOfBins2g: '10',
			powerDelta2g: '6',
			clusterRadius2g: '100',
			warningPwrDelta2g: '6',
			powerThreshold2g: '-90',
			qualityDelta2g: 'N/A',
			qualityThreshold2g: 'N/A',
			warningQualityDelta2g: 'N/A',
			// 3G
			numberOfBins3g: '10',
			powerDelta3g: '6',
			clusterRadius3g: '100',
			warningPwrDelta3g: '6',
			powerThreshold3g: '-95',
			qualityDelta3g: '6',
			qualityThreshold3g: '-10',
			warningQualityDelta3g: '5',
			// 4G
			numberOfBins4g: '10',
			powerDelta4g: '6',
			clusterRadius4g: '100',
			warningPwrDelta4g: '6',
			powerThreshold4g: '-100',
			qualityDelta4g: '6',
			qualityThreshold4g: '-10',
			warningQualityDelta4g: '5'
		},
		touched: {},
		errors: {},
	},
};

const algorithmsReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_ALGORITHMS_CITIES: {
						return {
							...state,
							algoCities: action.cities
						};
					}
					case GET_ALGORITHMS_DATES: {
						return {
							...state,
							algoDates: action.dates
						};
					}
					// case RUN_ALGORITHM_OVERSHOOTING: {
					// 	return {
					// 		...state,
					// 		algoFilePath: action.filePath
					// 	};
					// }
					default: {
						return state;
					}
	}
};

export default algorithmsReducer;
